export default "__VITE_ASSET__zs6Wzu7I__"